












































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Rate } from '@/modules/backend/Entities/Rate';
import RateEditDialog from '@/components/rates/RateEditDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import RateAddDialog from '@/components/rates/RateAddDialog.vue';
import RateDeleteButton from '@/components/rates/RateDeleteButton.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import { currency } from '@/filters/currency';

@Component({
  mixins: [Mixin],
  filters: {
    currency
  },
  components: {
    'rate-delete-button': RateDeleteButton,
    'data-table-wrapper': DataTableWrapper,
    'rate-edit-dialog': RateEditDialog,
    'rate-add-dialog': RateAddDialog
  }
})
export default class RatesComponent extends Mixins(Mixin) {
  @Prop({ required: false, default: [], type: Array }) private readonly rates!: Rate[];
  @Prop({ required: true, type: Number }) private readonly accountId!: number;
  @Prop({ type: Boolean, default: false }) private readonly loading!: number;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        value: 'id',
        sortable: false
      },
      {
        text: this.$i18n.t('screens.rates.dialog_fields.name').toString(),
        value: 'resource.title'
      },
      {
        align: 'center',
        text: this.$i18n.t('screens.rates.dialog_fields.price').toString(),
        value: 'price'
      },
      {
        align: 'end',
        text: this.$i18n.t('common.table.headers.actions').toString(),
        value: 'actions',
        sortable: false
      }
    ];
  }
}
